import React from "react";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Box, Container } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const PageHeader = () => {
  const { t } = useTranslation();

  return (
    <Container maxWidth='lg'>
      <Box sx={{ color: "text.primary", padding: "42px 0 26px" }}>
        <Typography mb={1.2} variant="h4" sx={{ fontWeight: 800, letterSpacing: "-0.01em", background: "linear-gradient(135deg,#0F172A 0%,#2563EB 70%,#7C3AED 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
          {t("exams")}
        </Typography>
        <Breadcrumbs aria-label="breadcrumb" style={{ color: "#94A3B8" }}>
          <Link className="underline-hover" to="/">
            {t('home')}
          </Link>
          <Typography sx={{ color: "text.secondary", fontWeight: 600 }}>{t('exams')}</Typography>
        </Breadcrumbs>
      </Box>
    </Container>
  );
};

export default PageHeader;
